import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

export interface ListItem<T>
{
  data: T;
  name: string;
  icon?: string;
}

@Component({
  selector: 'app-basic-list',
  templateUrl: './basic-list.component.html',
  styleUrls: ['./basic-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicListComponent {
  @Input()
  public options: ListItem<any>[] = [];

  @Input()
  public selectedValue: any = undefined;
  @Output()
  public selectedValueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private cdr: ChangeDetectorRef,
  ) {
  }

  public setSelectedValue(item: any): void {
    this.selectedValue = item;
    this.selectedValueChange.emit(this.selectedValue);
    this.cdr.markForCheck();
  }

  public trackItem(index: number, item: ListItem<any>): string {
    return item.name;
  }
}
